// extracted by mini-css-extract-plugin
export default {"drop":"edit_drop__sfWaG"};